import { AppConfig, AppConfigService, AppService } from '@aperza/util';
import React from 'react';
const appConfig = AppService.appConfig();
/**
 * Aperza Logo placeholder for various Aperza's sites.
 *
 * If the logoClassName is empty, the component will automatically detect the environment and apply the appropriate values.
 */
const Brand = (props) => {
    const brandConfig = () => {
        let logoClassName = 'logo';
        let url = appConfig.mainPage;
        let imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo.svg`);
        let disableLogoLink = false;
        if (appConfig.isAperzaCatalog) {
            logoClassName = 'logo-catalog';
            url = `${appConfig.searchWebHost}${appConfig.langCode === 'ja' ? '' : `/${appConfig.langCode}`}/catalog`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo_catalog.svg`);
        }
        else if (appConfig.isAperzaMarketplace || AppConfigService.shouldShowMarketplaceTopBanner()) {
            if (appConfig.langCode === 'en') {
                logoClassName = 'logo-ec-en';
            }
            else {
                logoClassName = 'logo-ec-ja';
            }
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo_ec.svg`);
            url = `${appConfig.mainPage}`;
        }
        else if (appConfig.serviceType === AppConfig.APERZA_NEWS) {
            logoClassName = 'logo-news';
            url = `//news${appConfig.baseDomain}`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo_news.svg`);
        }
        else if (appConfig.isAperzaIdDomain) {
            logoClassName = 'logo-id';
            url = `${appConfig.aperzaIdHost}`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo.svg`);
        }
        else if (appConfig.isAperzaAccountDomain) {
            logoClassName = 'logo-id';
            url = `${appConfig.aperzaAccountHost}`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo.svg`);
        }
        else if (appConfig.isAperzaOrderDomain) {
            logoClassName = 'logo-ec-ja';
            url = `${appConfig.marketplaceWebHost}`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo_ec.svg`);
            if (AppConfigService.isOrderCheckout() || AppConfigService.isOrderRegister()) {
                disableLogoLink = true;
            }
        }
        else if (appConfig.isAperzaBusinessDomain) {
            logoClassName = 'logo-ec-ja';
            url = `${appConfig.marketplaceWebHost}`;
            imageUrl = AppService.staticUrlWithProtocol(`/common/images/aperza2022/red/logo_ec.svg`);
            if (AppConfigService.isBusinessSignup()) {
                disableLogoLink = true;
            }
        }
        return {
            logoClassName,
            linkUrl: url,
            disableLink: disableLogoLink,
            imageUrl
        };
    };
    const renderBrand = () => {
        const config = brandConfig();
        const logoClassName = props.logoClassName ? props.logoClassName : config.logoClassName;
        const url = props.linkUrl ? props.linkUrl : config.linkUrl;
        const disableLogoLink = props.disableLink ? props.disableLink : config.disableLink;
        if (disableLogoLink) {
            return (React.createElement("div", { className: "logo-container" },
                React.createElement("img", { className: logoClassName, src: config.imageUrl, alt: logoClassName })));
        }
        return (React.createElement("div", { className: "logo-container" },
            React.createElement("a", { href: url, target: "_self" },
                React.createElement("img", { className: logoClassName, src: config.imageUrl, alt: logoClassName }))));
    };
    return React.createElement(React.Fragment, null, renderBrand());
};
Brand.defaultProps = {
    disableLink: false,
};
export default Brand;
export { Brand };
